import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import {InstiService} from './insti.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
 
  constructor(private router: Router,
              private service: InstiService) { }
 // private isAuthenticated: boolean = false;


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    /*
     *  let excepts_urls=[this.service.getLoginUrl(true), this.service.getLogoutUrl(true)];
            var instance=this;
     */
      let user = this.service.getUserData();

      if(!user || user == null || user === null){  
        this.router.navigate([this.service.getLoginUrl()]);
        return false;
      }

     return true; 
      
     var instance=this;
     
     if(!instance.service.isLogged()){
        instance.service.showAlert('Você não tem permissão para acessar esta página', 'Faça o login e tente novamente', 'error');
        instance.router.navigate([instance.service.getLoginUrl(true)]);
      }
      
        return true;
    }
}
